import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            探索分类
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            五大内容板块，全方位解读换妻文化的方方面面
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center text-center p-5 rounded-lg bg-background-100 border border-background-200/70 transition-all duration-200 hover:border-primary-300 hover:bg-background-50"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1.5 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-2">
                {cat.description}
              </p>
              <span className="text-xs text-primary-600 font-medium">
                {cat.articleCount} 篇文章
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}